<template>
  <div class='avue-top'>
    <div class='top-bar__left'>
      <router-link to='/'>首页</router-link>
    </div>
    <h1 class='top-bar__title'>
      <span class='top-bar__item'>
        <top-search></top-search>
      </span>
    </h1>
    <div class='top-bar__right'>
      <!-- <el-tooltip effect='dark'
                  content='用户头像'
                  placement='bottom'>
        <img class='top-bar__img'
             :src='userInfo.avatar'>
      </el-tooltip> -->
      <el-dropdown>
        <span class='el-dropdown-link'>
          {{userInfo.username}}
          <i class='el-icon-arrow-down el-icon--right'></i>
        </span>
        <el-dropdown-menu slot='dropdown'>
          <el-dropdown-item>
            <router-link to='/info/index'>个人信息</router-link>
          </el-dropdown-item>
          <el-dropdown-item @click.native='logout'
                            divided>退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import topSearch from './top-search'
export default {
  components: { topSearch },
  name: 'top',
  data () {
    return {
      userInfo: {
        avatar: '',
        username: ''
      }
    }
  },
  filters: {},
  created () { },
  mounted () {
  },
  computed: {
  },
  methods: {
    logout () {
      this.$confirm('是否退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push({ path: '/login' })
        })
      })
    }
  }
}
</script>

<style scoped>
  .avue-top {
    position: relative;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
    color: rgba(0, 0, 0, .65);
    font-size: 18px;
    padding: 0 10px;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .top-menu {
    box-sizing: border-box;
    .el-menu-item {
      padding: 0 15px;
      height: 50px !important;
      line-height: 50px !important;
    }
    .el-menu--horizontal>.el-menu-item.is-active {
      border: transparent;
    }
  }

  .top-search {
    position: absolute !important;
    top: 10px;
    left: 20px;
    width: 400px !important;
    .el-input__inner {
      border: none;
      background-color: transparent;
    }
  }

  .top-bar__img {
    margin: 0 8px 0 5px;
    padding: 2px;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    box-sizing: border-box;
    border: 1px solid #eee;
    vertical-align: middle;
  }

  .top-bar__left,
  .top-bar__right {
    position: absolute;
    top: 0;
  }

  .top-bar__left {
    left: 0;
  }

  .top-bar__right {
    padding: 8px 10px;
    right: 0;
  }

  .top-bar__title {
    padding-left: 40px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: inherit;
    font-weight: 400;
  }

  .top-bar__item {
    position: relative;
    display: inline-block;
    margin-right: 15px;
    height: 50px;
    &--show {
      display: inline-block !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/top/index.vue